import { Providers } from "./Providers";
import { AppRouter } from "./Router";

export default function App() {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
